import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi, { HttpBackendOptions } from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

void i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(HttpApi)
  .init<HttpBackendOptions>({
    debug: false,
    returnNull: false,
    fallbackLng: "en",
    nonExplicitSupportedLngs: true,
    ns: "DS.CommonPlatformServices.CustomerPortal",
    backend: {
      loadPath: "/translations/{{ns}}.{{lng}}.json"
    },
    detection: {
      order: ["navigator"]
    },
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    }
  });

export default i18n;
